<template>
    <div class="">
        <!-- Talleres de Escuela Orsai -->
        <div v-if="!loading && !error && escuelaProducts.length > 0"
            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 mt-4">
            <div v-for="product in escuelaProducts" :key="product.id" class="post-item max-w-md w-full mx-auto">
                <div class="bg-white rounded-2xl shadow-md border border-gray-200 flex flex-col h-full">
                    <a :href="product.onlineStoreUrl" target="_blank"
                        class="block w-full aspect-square overflow-hidden rounded-t-2xl">
                        <img v-if="product.featuredImage" :src="product.featuredImage.url" :alt="product.title"
                            class="w-full h-full object-cover rounded-t-2xl" />
                    </a>
                    <h3 class="text-lg font-bold mb-2 leading-tight text-black px-4 pt-4">{{ product.title }}</h3>
                    <!-- <div class="text-gray-700 text-base mb-2">
                        {{ product.totalInventory === 1
                            ? `¡Queda 1 cupo!`
                            : `¡Quedan ${product.totalInventory} cupos de ${getCupoMaximo(product)}!` }}
                    </div> -->
                    <div class="flex items-center justify-between mt-4 px-4 pb-4">
                        <span class="text-2xl text-gray-900">{{ formatPrice(product.priceRange.minVariantPrice.amount)
                        }}</span>
                        <a :href="product.onlineStoreUrl" target="_blank"
                            class="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg uppercase text-base transition-colors ml-4">
                            Reservar
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Talleres de Casciari -->
        <div v-if="!loading && !error && casciariProducts.length > 0" class="mt-16">
            <hr class="border-t border-gray-200 mb-8">
            <h2 class="">
                <span class="text-3xl font-bold">Taller virtual con Hernán Casciari</span>
            </h2>
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 mt-8">
                <div v-for="product in casciariProducts" :key="product.id" class="post-item max-w-md w-full mx-auto">
                    <div class="bg-white rounded-2xl shadow-md border border-gray-200 flex flex-col h-full">
                        <a :href="product.onlineStoreUrl" target="_blank"
                            class="block w-full aspect-square overflow-hidden rounded-t-2xl">
                            <img v-if="product.featuredImage" :src="product.featuredImage.url" :alt="product.title"
                                class="w-full h-full object-cover rounded-t-2xl" />
                        </a>
                        <h3 class="text-lg font-bold mb-2 leading-tight text-black px-4 pt-4">{{ product.title }}</h3>
                        <div class="text-gray-700 text-base mb-2 px-4 pb-4">INSCRIPCIÓN ABIERTA</div>
                        <div class="flex items-center justify-between mb-2 mt-auto px-4 pb-4">
                            <span class="text-2xl text-gray-900">{{
                                formatPrice(product.priceRange.minVariantPrice.amount) }}</span>
                            <a :href="product.onlineStoreUrl" target="_blank"
                                class="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg uppercase text-base transition-colors ml-4">
                                Reservar
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "ProductList",
    data() {
        return {
            escuelaProducts: [],
            casciariProducts: [],
            loading: true,
            error: null,
        };
    },
    methods: {
        formatPrice(price) {
            return `$${parseFloat(price).toLocaleString('es-AR')}`;
        },
        formatTitle(title) {
            const words = title.toUpperCase().split(' ');
            if (words.length > 3) {
                const firstHalf = words.slice(0, Math.ceil(words.length / 2)).join(' ');
                const secondHalf = words.slice(Math.ceil(words.length / 2)).join(' ');
                return `${firstHalf}\n${secondHalf}`;
            }
            return title.toUpperCase();
        },
        getInstructorName(product) {
            if (product.title.includes("con")) {
                const parts = product.title.split("con");
                if (parts.length > 1) {
                    return parts[1].trim().toUpperCase();
                }
            }
            return "DOLORES REYES";
        },
        getDateText(product) {
            return product.description.split("\n")[0];
        },
        getTimeText(product) {
            return "15 A 18 HS";
        },
        processProductEdges(edges) {
            return edges.map((edge) => ({
                id: edge.node.id,
                title: edge.node.title,
                handle: edge.node.handle,
                onlineStoreUrl: edge.node.onlineStoreUrl || `https://tienda.orsai.org/products/${edge.node.handle}`,
                priceRange: edge.node.priceRange,
                featuredImage: edge.node.featuredImage || null,
                description: edge.node.description || "",
                totalInventory: edge.node.totalInventory || 0,
            }));
        },
        async fetchProducts() {
            try {
                console.log("Fetching products from Shopify...");
                const query = `
                    {
                        tallerCasciari: collection(handle: "taller-casciari") {
                            products(first: 250) {
                                edges {
                                    node {
                                        id
                                        title
                                        handle
                                        onlineStoreUrl
                                        priceRange {
                                            minVariantPrice {
                                                amount
                                                currencyCode
                                            }
                                        }
                                        featuredImage {
                                            url
                                            altText
                                        }
                                        description(truncateAt: 150)
                                        totalInventory
                                    }
                                }
                            }
                        }
                        escuelaOrsai: collection(handle: "escuela-prueba") {
                            products(first: 250) {
                                edges {
                                    node {
                                        id
                                        title
                                        handle
                                        onlineStoreUrl
                                        priceRange {
                                            minVariantPrice {
                                                amount
                                                currencyCode
                                            }
                                        }
                                        featuredImage {
                                            url
                                            altText
                                        }
                                        description(truncateAt: 150)
                                        totalInventory
                                    }
                                }
                            }
                        }
                    }
                `;

                const response = await axios.post(
                    "https://tienda.orsai.org/api/2023-10/graphql.json",
                    { query },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "X-Shopify-Storefront-Access-Token": "0601f486448cb11b7bb5991ac5b7e907",
                        },
                    }
                );

                this.casciariProducts = this.processProductEdges(
                    response.data.data.tallerCasciari?.products?.edges || []
                );

                this.escuelaProducts = this.processProductEdges(
                    response.data.data.escuelaOrsai?.products?.edges || []
                );

            } catch (error) {
                console.error("Error fetching products:", error);
                this.error = "Error al cargar los productos: " + error.message;
            } finally {
                this.loading = false;
            }
        }
    },
    async mounted() {
        await this.fetchProducts();
    },
};
</script>

<style scoped>
.product-title {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
</style>

<script setup>
// Helper para cupo máximo
const getCupoMaximo = (product) => product.cupoMaximo || 100;
</script>